import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function BCSITQ() {
  const [activeAccordion, setActiveAccordion] = useState('entry-req');
  return (
    <>
      <Header />
      
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dkt3.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Animated Pattern Overlay */}
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          
          {/* Gradient Border Bottom */}
          <div style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '5px',
            background: 'linear-gradient(90deg, #B17ACC 0%, #7B3F9E 50%, #B17ACC 100%)',
            backgroundSize: '200% 100%',
            animation: 'shimmer 3s ease-in-out infinite'
          }}></div>
          
          <div className="container" style={{ position: 'relative', zIndex: 2, padding: '80px 20px' }}>
            <div className="row justify-content-center text-center">
              <div className="col-lg-8">
                {/* Animated Badge */}
                <div style={{
                  display: 'inline-block',
                  backgroundColor: 'rgba(123, 63, 158, 0.2)',
                  backdropFilter: 'blur(10px)',
                  padding: '12px 30px',
                  borderRadius: '50px',
                  marginBottom: '30px',
                  border: '2px solid rgba(123, 63, 158, 0.4)',
                  boxShadow: '0 4px 20px rgba(123, 63, 158, 0.2)'
                }}>
                  <span style={{ 
                    color: '#e0d9e4ff', 
                    fontSize: '0.9rem', 
                    fontWeight: '700', 
                    letterSpacing: '2px',
                    textShadow: '0 0 10px rgba(123, 63, 158, 0.5)'
                  }}>
                    🖥️ IT USER SKILLS
                  </span>
                </div>
                
                <h1 style={{ 
                  fontSize: '4.5rem', 
                  fontWeight: '800',
                  color: 'white',
                  marginBottom: '30px',
                  lineHeight: '1.1',
                  letterSpacing: '-2px',
                  textShadow: '0 4px 30px rgba(0,0,0,0.5), 0 0 60px rgba(123, 63, 158, 0.2)'
                }}>
                  BCS Level 2 Certificate in IT User Skills
                </h1>
                
                {/* Decorative Line */}
                <div style={{
                  width: '150px',
                  height: '6px',
                  background: 'linear-gradient(90deg, transparent, #B17ACC, transparent)',
                  margin: '0 auto 35px',
                  borderRadius: '10px',
                  boxShadow: '0 0 20px rgba(123, 63, 158, 0.5)'
                }}></div>
                
                <p style={{
                  fontSize: '1.4rem',
                  color: 'rgba(255,255,255,0.95)',
                  maxWidth: '700px',
                  margin: '0 auto',
                  lineHeight: '1.8',
                  textShadow: '0 2px 15px rgba(0,0,0,0.3)',
                  fontWeight: '300'
                }}>
                  Nationally recognized IT qualification for practical skills
                </p>
              </div>
            </div>
          </div>
          
          <style>{`
            @keyframes float {
              0%, 100% { transform: translateY(0px); }
              50% { transform: translateY(-20px); }
            }
            @keyframes shimmer {
              0% { background-position: 200% 0; }
              100% { background-position: -200% 0; }
            }
          `}</style>
        </section>

        {/* Content Section */}
        <section id="bcs-itq" className="section" style={{ padding: '80px 0' }}>
          <div className="container" data-aos="fade-up">
            
            <div className="row justify-content-center">
              <div className="col-lg-10">
                
                {/* Overview */}
                <div className="mb-5 p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h2 style={{ 
                    fontSize: '2.5rem', 
                    fontWeight: '700', 
                    color: '#1e293b',
                    marginBottom: '25px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <span style={{ fontSize: '2rem' }}>📖</span> Overview
                  </h2>
                  <div style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                    <p>
                      Individuals will gain the digital skills needed to succeed and thrive, through outstanding and aspirational teaching, learning and skills development.
                    </p>
                    <p>
                      The course is for anyone who wants to build upon their existing IT and Internet skills, knowledge, and experience to improve their understanding of computer applications including improving productivity using IT, word processing, spreadsheets, and presentation software to gain a practical and up to date qualification that is also attractive to employers.
                    </p>
                    <p style={{ marginBottom: 0 }}>
                      The programme will allow you to learn at your own pace online, in our IT suite, in your own home or workplace at a time that is suitable to you. Throughout your course you will also be supported by a tutor.
                    </p>
                  </div>
                </div>

                {/* Course Units */}
                <div className="mb-5 p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ 
                    fontSize: '2rem', 
                    fontWeight: '700', 
                    color: '#1e293b',
                    marginBottom: '25px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <span style={{ fontSize: '1.8rem' }}>📚</span> Course Units
                  </h3>
                  <p style={{ fontSize: '1.05rem', color: '#475569', marginBottom: '25px' }}>
                    As part of this course, you will study four mandatory units:
                  </p>
                  <div className="row g-3">
                    {[
                      { number: '1', title: 'Word Processing Software', icon: '📝', color: '#e0d9e4ff', description: null },
                      { number: '2', title: 'Presentation Software', icon: '📽️', color: '#f59e0b', description: null },
                      { number: '3', title: 'Spreadsheet Software', icon: '📊', color: '#8b5cf6', description: null },
                      { number: '4', title: 'Improving Productivity Using IT', icon: '⚡', color: '#3b82f6', description: 'So you can plan, evaluate, and improve procedures involving the use of IT tools and systems to improve the productivity and efficiency of work activities.' }
                    ].map((unit, index) => (
                      <div key={index} className="col-md-6">
                        <div style={{
                          backgroundColor: '#f8fafc',
                          padding: '25px',
                          borderRadius: '12px',
                          border: `2px solid ${unit.color}20`,
                          display: 'flex',
                          alignItems: 'center',
                          gap: '15px'
                        }}>
                          <div style={{
                            backgroundColor: unit.color,
                            color: 'white',
                            width: '50px',
                            height: '50px',
                            borderRadius: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '1.5rem',
                            fontWeight: '700',
                            flexShrink: 0
                          }}>
                            {unit.number}
                          </div>
                          <div>
                            <div style={{ fontSize: '1.5rem', marginBottom: '5px' }}>{unit.icon}</div>
                            <div style={{ 
                              fontSize: '1.05rem', 
                              fontWeight: '600', 
                              color: '#1e293b',
                              lineHeight: '1.4',
                              marginBottom: unit.description ? '8px' : 0
                            }}>
                              {unit.title}
                            </div>
                            {unit.description && (
                              <div style={{
                                fontSize: '0.9rem',
                                color: '#64748b',
                                lineHeight: '1.5',
                                marginTop: '8px'
                              }}>
                                {unit.description}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Assessment Methods */}
                <div className="mb-5 p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ 
                    fontSize: '2rem', 
                    fontWeight: '700', 
                    color: '#1e293b',
                    marginBottom: '25px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <span style={{ fontSize: '1.8rem' }}>📝</span> Assessment Methods
                  </h3>
                  <div style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                    <p style={{ marginBottom: 0 }}>
                      Assessments are due at the end of each completed unit. Your tutor will assess your work and a certificate will be awarded on passing all four units to be awarded the <strong style={{ color: '#7B3F9E' }}>BCS Level 2 Certificate in IT User Skills (ECDL Extra)</strong>.
                    </p>
                  </div>
                </div>

                {/* Course Details Accordion */}
                <div className="shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0',
                  overflow: 'hidden'
                }}>
                  <div style={{
                    backgroundColor: '#7b5ba1',
                    color: 'white',
                    padding: '25px',
                    textAlign: 'center'
                  }}>
                    <h4 style={{ 
                      fontSize: '1.5rem', 
                      fontWeight: '700', 
                      marginBottom: 0 
                    }}>
                      Course Details
                    </h4>
                  </div>

                  {/* Accordion Items */}
                  <div>
                    {/* Entry Requirements */}
                    <div style={{ borderBottom: '1px solid #e2e8f0' }}>
                      <button
                        onClick={() => setActiveAccordion(activeAccordion === 'entry-req' ? '' : 'entry-req')}
                        style={{
                          width: '100%',
                          padding: '20px 25px',
                          backgroundColor: activeAccordion === 'entry-req' ? '#7b5ba1' : 'transparent',
                          color: activeAccordion === 'entry-req' ? 'white' : '#1e293b',
                          border: 'none',
                          textAlign: 'left',
                          fontSize: '1.1rem',
                          fontWeight: '600',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center'
                        }}
                      >
                        <span>Entry Requirements</span>
                        <i className={`bi bi-chevron-${activeAccordion === 'entry-req' ? 'up' : 'down'}`}></i>
                      </button>
                      {activeAccordion === 'entry-req' && (
                        <div style={{
                          padding: '20px 25px',
                          backgroundColor: '#f8fafc',
                          color: '#475569',
                          fontSize: '1rem',
                          lineHeight: '1.6'
                        }}>
                          To view eligibility criteria for our FREE Level 2 Distance Learning courses.<br/><br/>
                          <span style={{ color: '#ef4444', fontWeight: '600' }}>An administration fee will be incurred if you withdraw from the course</span>
                        </div>
                      )}
                    </div>

                    {/* Attendance Requirements */}
                    <div style={{ borderBottom: '1px solid #e2e8f0' }}>
                      <button
                        onClick={() => setActiveAccordion(activeAccordion === 'attendance-req' ? '' : 'attendance-req')}
                        style={{
                          width: '100%',
                          padding: '20px 25px',
                          backgroundColor: activeAccordion === 'attendance-req' ? '#7b5ba1' : 'transparent',
                          color: activeAccordion === 'attendance-req' ? 'white' : '#1e293b',
                          border: 'none',
                          textAlign: 'left',
                          fontSize: '1.1rem',
                          fontWeight: '600',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center'
                        }}
                      >
                        <span>Attendance Requirements</span>
                        <i className={`bi bi-chevron-${activeAccordion === 'attendance-req' ? 'up' : 'down'}`}></i>
                      </button>
                      {activeAccordion === 'attendance-req' && (
                        <div style={{
                          padding: '20px 25px',
                          backgroundColor: '#f8fafc',
                          color: '#475569',
                          fontSize: '1rem',
                          lineHeight: '1.6'
                        }}>
                          Blended learning, you will need to attend College some time. For further information or advice, please contact the Distance Learning team:<br/><br/>
                          <strong>Phone:</strong> 0208 555 2999<br/>
                          <strong>Email:</strong> <a href="mailto:admin@dtkcollege.co.uk" style={{ color: '#7B3F9E', textDecoration: 'none' }}>admin@dtkcollege.co.uk</a>
                        </div>
                      )}
                    </div>

                    {/* GLH */}
                    <div>
                      <button
                        onClick={() => setActiveAccordion(activeAccordion === 'glh' ? '' : 'glh')}
                        style={{
                          width: '100%',
                          padding: '20px 25px',
                          backgroundColor: activeAccordion === 'glh' ? '#7b5ba1' : 'transparent',
                          color: activeAccordion === 'glh' ? 'white' : '#1e293b',
                          border: 'none',
                          textAlign: 'left',
                          fontSize: '1.1rem',
                          fontWeight: '600',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center'
                        }}
                      >
                        <span>GLH</span>
                        <i className={`bi bi-chevron-${activeAccordion === 'glh' ? 'up' : 'down'}`}></i>
                      </button>
                      {activeAccordion === 'glh' && (
                        <div style={{
                          padding: '20px 25px',
                          backgroundColor: '#f8fafc',
                          color: '#475569',
                          fontSize: '1rem',
                          lineHeight: '1.6'
                        }}>
                          120 hours
                        </div>
                      )}
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

export default BCSITQ;
